import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@skyslope/mache';
import cs from 'classnames';
import { SHELF_WIDTH } from '../../lib/constants';

const useStyles = makeStyles<never, BuilderShelfWrapperProps>(
  {
    shelf: {
      position: 'fixed',
      top: '156px',
      bottom: 0,
      transform: (p) => `translateX(calc(${p.side === 'right' ? +1 : -1} * ${SHELF_WIDTH / 4}px))`,
      width: SHELF_WIDTH,
      textAlign: 'left',
      color: colors.grey[800],
      // packages/sender/src/components/senderBuild/FooterControls.tsx has z-index set to 1200
      zIndex: 1201,
      overflowY: 'auto',
      transition: 'all 0.25s',
      opacity: 0,
      pointerEvents: 'none',
      borderTopWidth: 0,
    },
    in: {
      transform: 'translateX(0) !important',
      opacity: '1 !important',
      pointerEvents: 'initial !important' as any,
    },
  },
  { classNamePrefix: 'BuilderShelfWrapper' }
);

interface BuilderShelfWrapperProps extends React.ComponentProps<'div'> {
  show: boolean;
  side?: 'left' | 'right';
}

export function BuilderShelfWrapper(props: BuilderShelfWrapperProps) {
  const { children, className, show, side } = props;
  const classes = useStyles(props);
  return (
    <div className={cs(classes.shelf, show && classes.in, side === 'right' && 'right-0', className)}>
      {show ? children : null}
    </div>
  );
}
